
  import { integrationsService } from '@/services/integrations/integrationsService';
  import { Integration } from '@/services/integrations/types';
  import { Icon } from '@/ui/components/icon/Icon';
  import { computed, defineComponent } from 'vue';

  interface StatusProps {
    integration: Integration;
    showEmpty?: boolean;
  }

  export default defineComponent<StatusProps>({
    name: 'Status',
    components: {
      Icon,
    },
    props: ['integration', 'showEmpty'],
    setup(props) {
      const enabled = computed(() => integrationsService.isEnabled(props.integration));
      const paused = computed(() => integrationsService.isPaused(props.integration));

      return {
        isEnabled: enabled,
        isPaused: paused,
      };
    },
  });
